// Alert method metadata, default configs, severity styles.

export const METHODS = [
  { value: "threshold", label: "Threshold", hint: "Fire when the value crosses a fixed line." },
  { value: "pct_change", label: "% change", hint: "Fire on a big move vs a prior period (e.g. week-over-week)." },
  { value: "zscore", label: "Z-score", hint: "Fire when the value is a statistical outlier vs recent history." },
  { value: "seasonal", label: "Seasonal", hint: "Outlier vs a day-of-week / weekly baseline (ignores expected dips)." },
];

export const DEFAULT_CONFIG = {
  threshold: { op: "<", threshold: 0 },
  pct_change: { period_days: 7, drop_pct: 20, direction: "down" },
  zscore: { window: 30, sensitivity: 3, direction: "both" },
  seasonal: { sensitivity: 2.5, season: "dow", direction: "both" },
};

export const OPS = ["<", "<=", "==", ">=", ">"];
export const DIRECTIONS = [
  { value: "down", label: "Drop" },
  { value: "up", label: "Rise" },
  { value: "both", label: "Either" },
];
export const SEASONS = [
  { value: "dow", label: "Day of week" },
  { value: "woy", label: "Week of year" },
  { value: "dow_woy", label: "Day + week" },
];

export const SEVERITY = {
  high: { label: "High", cls: "text-red-400 border-red-500/40 bg-red-500/10", dot: "bg-red-400" },
  medium: { label: "Medium", cls: "text-amber-400 border-amber-500/40 bg-amber-500/10", dot: "bg-amber-400" },
  low: { label: "Low", cls: "text-sky-400 border-sky-500/40 bg-sky-500/10", dot: "bg-sky-400" },
};

export function methodLabel(v) {
  return METHODS.find((m) => m.value === v)?.label || v;
}

export function describeConfig(method, c = {}) {
  if (method === "threshold") return `value ${c.op || "<"} ${c.threshold ?? 0}`;
  if (method === "pct_change") return `${c.direction || "down"} ≥ ${c.drop_pct ?? 20}% vs ${c.period_days ?? 7}d`;
  if (method === "zscore") return `|z| > ${c.sensitivity ?? 3} over ${c.window ?? 30} pts`;
  if (method === "seasonal") return `seasonal |z| > ${c.sensitivity ?? 2.5} (${c.season || "dow"})`;
  return "";
}
